import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import PhotoManager from './components/PhotoManager';

// Mapping des catégories d'affichage vers les catégories techniques
const categoryMapping: Record<string, string> = {
  'portrait': 'portrait',
  'paysages': 'Paysages',
  'voiture': 'Voitures',
  'tournages': 'Tournages'
};

type AdminTab = 'portrait' | 'paysages' | 'voiture' | 'tournages';

const Dashboard: React.FC = () => {
  const { isAuthenticated, user, logout } = useAuth();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<AdminTab>('portrait');

  // Rediriger vers la page de connexion si non authentifié
  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/admin/login");
    }
  }, [isAuthenticated, navigate]);

  if (!isAuthenticated) {
    return null;
  }

  return (
    <div className="flex h-screen bg-gray-900">
      {/* Sidebar */}
      <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} logout={logout} />

      {/* Contenu principal */}
      <div className="flex-1 overflow-auto">
        <header className="bg-gray-800 shadow-md border-b border-gray-700">
          <div className="max-w-7xl mx-auto py-4 px-4 sm:px-6 lg:px-8 flex justify-between items-center">
            <div className="flex items-center">
              <h1 className="text-2xl font-serif text-white">
                𝓨𝓸𝓱𝓪𝓷𝓥𝓲𝓼𝓲𝓸𝓷
              </h1>
              <span className="ml-3 text-gray-400 text-lg">Administration</span>
            </div>
            <div className="flex items-center">
              <span className="mr-4 text-gray-300">
                Connecté en tant que <span className="font-semibold text-white">{user?.username}</span>
              </span>
              <button
                onClick={logout}
                className="px-3 py-1 bg-gray-700 text-white rounded-md hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500 transition-colors"
              >
                Déconnexion
              </button>
            </div>
          </div>
        </header>

        <main className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
          {/* Gestionnaire de photos pour la catégorie active */}
          <PhotoManager category={categoryMapping[activeTab] || activeTab} />
        </main>
      </div>
    </div>
  );
};

export default Dashboard;
